import {
  CREATE_ORDER_FAIL,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  GET_ACTIVE_ORDER_PARTS_FAIL,
  GET_ACTIVE_ORDER_PARTS_REQUEST,
  GET_ACTIVE_ORDER_PARTS_SUCCESS,
  GET_ORDER_LIST_FAIL,
  GET_ORDER_LIST_REQUEST,
  GET_ORDER_LIST_SUCCESS,
  GET_ORDER_ORDER_PART_LIST_FAIL,
  GET_ORDER_ORDER_PART_LIST_REQUEST,
  GET_ORDER_ORDER_PART_LIST_SUCCESS,
  GET_ORDER_TYPE,
  GET_ORDER_TYPE_FAIL,
  GET_ORDER_TYPE_SUCCESS,
  GET_SINGLE_ORDER_FAIL,
  GET_SINGLE_ORDER_REQUEST,
  GET_SINGLE_ORDER_SUCCESS,
  GET_STEP1_ORDER_PARTS_FAIL,
  GET_STEP1_ORDER_PARTS_REQUEST,
  GET_STEP1_ORDER_PARTS_SUCCESS,
  GET_STEP2_ORDER_PARTS_FAIL,
  GET_STEP2_ORDER_PARTS_REQUEST,
  GET_STEP2_ORDER_PARTS_SUCCESS,
} from "src/constants/types";

export const orderReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_ORDER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: actions.payload,
        error: "",
      };
    case GET_ORDER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ORDER_ORDER_PART_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_ORDER_PART_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderOrderParts: actions.payload,
        error: "",
      };
    case GET_ORDER_ORDER_PART_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        order: actions.payload,
      };
    case GET_SINGLE_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        error: "",
      };

    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        error: "",
      };

    case CREATE_ORDER_FAIL:
      return {
        ...state,
        error: actions.payload,
      };

    case GET_STEP1_ORDER_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_STEP1_ORDER_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        step1OrderParts: actions.payload,
        error: "",
      };
    case GET_STEP1_ORDER_PARTS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_STEP2_ORDER_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_STEP2_ORDER_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        step2OrderParts: actions.payload,
        error: "",
      };
    case GET_STEP2_ORDER_PARTS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ACTIVE_ORDER_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ACTIVE_ORDER_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeOrderParts: actions.payload,
        error: "",
      };
    case GET_ACTIVE_ORDER_PARTS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ORDER_TYPE:
      return {
        ...state,
        loading: true,
        orderType: null,
        error: "",
      };

    case GET_ORDER_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        orderType: actions.payload,
        error: "",
      };
    case GET_ORDER_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
